import { isMultiSelectFilter, isRangeFilter, isBucketFilter, isLinkFilter } from '@as-react/common-utils';
/**
 * Map a SetFilterObject to FilteredItemWithFilterType for storage in activeFilters
 * Based on mapSetFilterObjectToFilteredItemWithFilterType from FilterReducer.ts
 */
const mapSetFilterObjectToFilteredItemWithFilterType = (setFilterObject) => {
    var _a, _b, _c, _d;
    let data = {
        filterType: setFilterObject.filterType,
        filterOnName: setFilterObject.filterOnName,
        filterContentType: setFilterObject.filterContentType,
        queryParamKey: setFilterObject.queryParamKey,
    };
    if (isMultiSelectFilter(setFilterObject)) {
        data = Object.assign(Object.assign({}, data), { values: setFilterObject.filteredItems.map((filterItem) => ({
                filterType: setFilterObject.filterType,
                filterOnName: setFilterObject.filterOnName,
                filterOn: setFilterObject.filterOn,
                filterKey: filterItem.filterKey,
                filterKeyName: filterItem.filterKeyName,
            })) });
    }
    else if (isRangeFilter(setFilterObject)) {
        data = Object.assign(Object.assign({}, data), { rangeMin: Number((_b = (_a = setFilterObject.filteredItems[0]) === null || _a === void 0 ? void 0 : _a.filterKey) !== null && _b !== void 0 ? _b : 0), rangeMax: Number((_d = (_c = setFilterObject.filteredItems[1]) === null || _c === void 0 ? void 0 : _c.filterKey) !== null && _d !== void 0 ? _d : 0), filterPrefix: setFilterObject.filterPrefix, filterSuffix: setFilterObject.filterSuffix });
    }
    else if (isBucketFilter(setFilterObject) || isLinkFilter(setFilterObject)) {
        const lastItem = setFilterObject.filteredItems[setFilterObject.filteredItems.length - 1];
        data = Object.assign(Object.assign({}, data), { values: lastItem ? [lastItem] : [] });
    }
    return data;
};
/**
 * Update active filters with a new filter
 */
export const updateActiveFilters = (currentActiveFilters, setFilterObject) => {
    const newFilteredItemWithFilterType = mapSetFilterObjectToFilteredItemWithFilterType(setFilterObject);
    return Object.assign(Object.assign({}, currentActiveFilters), { [setFilterObject.filterOn]: Object.assign({}, newFilteredItemWithFilterType) });
};
/**
 * Remove an attribute from an object (immutably)
 */
const removeAttributeFromObject = (sourceObject, attributeToRemove) => Object.keys(sourceObject)
    .filter(attribute => attribute !== attributeToRemove)
    .reduce((result, current) => {
    result[current] = sourceObject[current];
    return result;
}, {});
/**
 * Remove a filter from active filters
 */
export const removeFilterFromActiveFilters = (currentActiveFilters, filterOn) => {
    if (!currentActiveFilters || !currentActiveFilters[filterOn]) {
        return currentActiveFilters;
    }
    const newActiveFilters = removeAttributeFromObject(currentActiveFilters, filterOn);
    // Return undefined if no filters remain
    if (Object.keys(newActiveFilters).length === 0) {
        return undefined;
    }
    return newActiveFilters;
};
